module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/MH-1d1a3a42d92469c4f96295f6c6d18919.png";